import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  UpdateUnit,
} from "../../../redux/services/UnitService/unit.Services";

import {
  successToast,
  errorToast,
} from "../../../Utils/toast";

import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";


function EditBrand({ data, onSuccess }) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    status: true,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        status:
          data.status === 1 ||
          data.status === true,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "status"
          ? value === "Active"
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const payload = {
        id: data?.id,
        name: formData.name,
        status: formData.status ? 1 : 0,
      };

      const res = await UpdateUnit(payload);
      successToast(
        res?.message ||
        "Brand Updated Successfully"
      );
    
      dispatch(refreshProductList());
      dispatch(closeProductModal());


    } catch (err) {
      console.log(err);

      errorToast(
        err?.message ||
        "Error updating role"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">

      <form
        onSubmit={handleSubmit}
        className="row g-"
      >

        <div className="col-md-12">
          <label>Unit Name</label>

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter Unit name"
          />
        </div>

        <div className="col-md-12">
          <label>Status</label>

          <select
            name="status"
            value={
              formData.status
                ? "Active"
                : "Inactive"
            }
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">
              Active
            </option>

            <option value="Inactive">
              Inactive
            </option>
          </select>
        </div>

        <div className="col-md-12 text-end">
          <button
            type="submit"
            disabled={isLoading}
            className="add-btn"
          >
            {isLoading
              ? "Updating..."
              : "Update Unit"}
          </button>
        </div>

      </form>

    </div>
  );
}

export default EditBrand;